import { IconButton } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import { useSnackbar } from "../../misc/Snackbar";
import { taskPermalink } from "./TaskPicker";

// CopyLinkButton copies the task's permalink, to paste into a message or into a search
export function CopyLinkButton(props: {
    task: { id: number; team?: number; dueDate?: string | null };
    className?: string;
    opacity?: number;
}) {
    const snack = useSnackbar();

    return (
        <IconButton
            className={props.className}
            size="small"
            title="Copy link"
            sx={{ opacity: props.opacity, flexShrink: 0 }}
            onClick={async e => {
                e.stopPropagation();

                try {
                    await navigator.clipboard.writeText(taskPermalink(props.task));
                    snack.success("Link copied");
                } catch (err: any) {
                    snack.error(err.message);
                }
            }}
        >
            <LinkIcon fontSize="inherit" />
        </IconButton>
    );
}
